import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { DatePipe } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-mentor-feedback',
  templateUrl: './mentor-feedback.component.html',
  styleUrls: ['./mentor-feedback.component.scss']
})
export class MentorFeedbackComponent implements OnInit {

  feedbackForm!: FormGroup;
  mentor_data: any;
  selectedCourse: any = null;
  selectedStudent: any = null;
  courses: any;
  tableshow: boolean = false;

  modalTitle: string = '';
  modalContent: string = '';
  selectedCourseId: number;

  mentor: any = JSON.parse(localStorage.getItem('login_user_details'));
  userDistrict: string;
  userConstituency: string;
  userId: string;
  spinner: boolean = false;


  constructor(
    private fb: FormBuilder,
    private ApiService: ApiServiceService,
    private router: Router,
    public datepipe: DatePipe
  ) {
    this.userDistrict = this.ApiService.user_details.district;
    this.userConstituency = this.ApiService.user_details.constituency;
    this.userId = this.ApiService.user_details.id;
  }

  ngOnInit(): void {
    const storedUser = localStorage.getItem('login_user_details');
    if (storedUser) {
      this.mentor = JSON.parse(storedUser);
    } else {
      console.error('No user details found in localStorage');
      return;
    }

    this.initFeedbackForm();
    this.getAssignedCoursesForMentor(this.mentor.id);
    this.handleBackButtonForModal();
  }

  initFeedbackForm(): void {
    this.feedbackForm = this.fb.group({
      mentor_id: Number(this.mentor.id),
      course_id: [''],
      student_id: [''],
      overall_rating_about_session: [0],
      involvement: [''],
      volunteering: [''],
      performance: ['']
    });
  }

  getAssignedCoursesForMentor(mentorId: number): void {
    this.ApiService.studentEnrolledCourse(mentorId).subscribe(
      (data: any) => {
        if (data && Array.isArray(data.course)) {
          this.mentor_data = data.course.filter((course: any) => course.allow_course === "1");
        } else {
          console.error('Invalid course data format');
        }
      },
      (error) => {
        console.error('Error fetching assigned courses:', error);
      }
    );
  }

  onCourseChange(): void {
    this.selectedCourse = this.mentor_data.find(c => c.id == this.selectedCourseId);

    if (this.selectedCourse) {
      this.tableshow = true;
      this.courses = this.selectedCourse.enrolled_students.map((student: any) => ({
        course_name: this.selectedCourse.course_name,
        course_id: this.selectedCourse.id,
        student_name: student.student_name,
        student_email: student.student_email,
        student_number: student.student_number,
        student_id: student.student_id,
        student_feedback: student.student_feedback
      }));
    } else {
      this.tableshow = false;
      this.courses = [];
    }
  }

  show(course: any, action: string): void {
    if (course) {
      this.selectedStudent = {
        course_name: course.course_name,
        course_date: course.course_date,
        course_time: course.course_time,
        student_name: course.student_name,
        student_email: course.student_email,
        student_number: course.student_number,
        student_p_n: course.student_p_n
      };

      if (action === 'feedback') {
        this.modalTitle = 'Student Feedback';
        this.modalContent = 'feedback';
        this.feedbackForm.patchValue({
          course_id: course.course_id,
          student_id: course.student_id
        });
        $('#myFeedBackModal').modal('show');
      } else {
        this.modalTitle = action === 'edit' ? 'Edit Student’s Detail' : 'Student’s Detail';
      }
    }
  }

  submitFeedback(): void {
    this.ApiService.submitStudentFeedback(this.feedbackForm.value).subscribe(
      (response: any) => {
        if (response.status === 'success') {
          alert('Feedback submitted successfully!');
        } else {
          alert('Failed to submit feedback.');
        }
      },
      (error) => {
        console.error('Error submitting feedback:', error);
        alert('An error occurred while submitting feedback.');
      }
    );
  }

  updateRating(value: number): void {
    this.feedbackForm.patchValue({ overall_rating_about_session: value });
  }

  handleBackButtonForModal(): void {
    history.pushState(null, '', window.location.href);

    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
        history.pushState(null, '', window.location.href);
      } else {
        this.router.navigate(['previous-page']);
      }
    };
  }
}
